module.exports = __webpack_public_path__ + "images/9d515e3f2538496345db7da2bec13ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/euro_plus.png
// module id = 1278
// module chunks = 0